import { render, staticRenderFns } from "./TitleListSortingSwitchPopover.vue?vue&type=template&id=37c92c6c"
import script from "./TitleListSortingSwitchPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleListSortingSwitchPopover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleListSortingSwitchPopover.vue?vue&type=style&index=0&id=37c92c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports